import { DataTable } from "../components/DataTable";
import { StatusPill } from "../components/StatusPill";
import { fetchDashboardFollowers } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

export function FollowersPage() {
  const state = useDashboardQuery(fetchDashboardFollowers);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Followers</h1>
          <p>Registered follower accounts for this tenant. No equity or balance claims.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="No followers registered"
        emptyDetail="This tenant has no follower registrations yet."
      >
        {(data) => (
          <div className="panel">
            <div className="panel-body" style={{ paddingTop: 0 }}>
              <DataTable
                rows={data.followers}
                rowKey={(r) => r.followerId}
                columns={[
                  {
                    key: "follower",
                    header: "Follower",
                    render: (r) => <span className="mono">{r.followerId}</span>,
                  },
                  {
                    key: "name",
                    header: "Name",
                    render: (r) => r.name ?? "—",
                  },
                  {
                    key: "account",
                    header: "Account",
                    render: (r) => <span className="mono">{r.followerAccountId}</span>,
                  },
                  {
                    key: "broker",
                    header: "Broker provider",
                    render: (r) => r.brokerProvider ?? "—",
                  },
                  {
                    key: "rels",
                    header: "Relationships",
                    render: (r) => String(r.relationshipCount),
                  },
                ]}
              />
            </div>
          </div>
        )}
      </DashboardStateView>
    </>
  );
}
